import { authFetch } from '@/utils/authFetch';
import { API_URL } from '@/config/apiConfig';

export async function fetchSessionMessages(sessionId) {
  const res = await authFetch(`${API_URL}/api/cory/sessions/${sessionId}/messages`);
  if (!res.ok) return [];
  const data = await res.json();
  return data.messages || [];
}

export async function postChatMessage({ message, sessionId, business, diagnostics, screenshots }) {
  const res = await authFetch(`${API_URL}/api/cory/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message,
      session_id: sessionId,
      business_name: business?.name || 'My Business',
      industry: business?.industry || 'general',
      business_id: business?.business_id || null,
      diagnostics: diagnostics || null,
      screenshots: screenshots || [],
    }),
  });
  if (!res.ok) throw new Error('Chat request failed');
  return await res.json();
}

export async function submitCoryTicket({ ticketData, sessionId, screenshots, diagnostics }) {
  const res = await authFetch(`${API_URL}/api/cory/tickets`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...ticketData,
      session_id: sessionId,
      screenshots: screenshots || [],
      diagnostics: diagnostics || null,
    }),
  });
  if (!res.ok) return null;
  return await res.json();
}
